import { Box, Button, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { useState } from "react";
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useTranslation } from "../../hooks/useTranslation";


function VerifyDetailsDOB(props) {
  const { t } = useTranslation();
  const { handleClick,
    date,
    setDate,
    pan,
    setPan,
    isDobRequired,
    isPanRequired, } = props;
  const [panTouched, setPanTouched] = useState(false);
  const [dobTouched, setDobTouched] = useState(false);

  const handleChange = (event) => {
    setPan(event.target.value.toUpperCase());
  };

  const isPANValid = (value) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/i;
    return panRegex.test(value);
  };

  const isDobInvalid =
    isDobRequired &&
    dobTouched &&
    (!date || date === "Invalid Date" || date === "");

  const isPanInvalid =
    isPanRequired && panTouched && !isPANValid(pan);

  const onChange = (selectedDate) => {
    setDobTouched(true);
    if (selectedDate && selectedDate !== undefined) {
      setDate(selectedDate.format("YYYY-MM-DD"));
    } else {
      setDate("");
    }
  };

  return (
    <Box
      sx={{
        p: "0.63rem 0",
        display: "flex",
        flexDirection: "column",
        gap:"1rem",
        alignItems: "flex-start",
      }}
    >
      {isDobRequired && (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer sx={{ width: "100%" }} components={['DatePicker']}>
            <DatePicker
              slotProps={{
                textField: {
                  size: 'small',
                  ...sizeFontCustom.subHeading,
                  error: isDobInvalid,
                  helperText: isDobInvalid ? t('common.messages.dateOfBirthRequired') : '',
                  FormHelperTextProps: { role: 'alert' },
                  onBlur: () => setDobTouched(true),
                  inputProps: { autoComplete: 'bday' },
                },
              }}
              format="DD-MM-YYYY"
              sx={{ width: "100%", "& .MuiFormLabel-root-MuiInputLabel-root": { fontSize: "0.75rem" } }}
              label={t('common.labels.dateOfBirth')}
              value={date}
              onChange={onChange}
            />
          </DemoContainer>
        </LocalizationProvider>
      )}
      {isPanRequired && (
        <TextField
          name="pan"
          label={t('common.labels.pan')}
          placeholder={t('common.placeholders.enterPan')}
          focused={true}
          size="small"
          variant="outlined"
          onChange={handleChange}
          onBlur={() => setPanTouched(true)}
          fullWidth
          autoComplete="off"
          value={pan}
          error={isPanInvalid}
          helperText={isPanInvalid ? t('common.messages.validPan') : ''}
          FormHelperTextProps={{ role: 'alert' }}
          inputProps={{
            style: { fontSize: "0.875rem" },
            autoComplete: 'off',
          }}
          sx={{  ...sizeFontCustom.subHeading }}
        />
      )}
      <Button
        variant="contained"
        disabled={
          (isDobRequired && (date === "Invalid Date" || date === "" || !date)) ||
          (isPanRequired && !isPANValid(pan))
        } onClick={handleClick}
        sx={{
          textTransform: "capitalize",
          width: "100%",
        }}
      >
        {t('common.buttons.submit')}
      </Button>
    </Box>
  );
}

export default VerifyDetailsDOB;
